import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { UserSearch } from '../UserSearch/UserSearch';

export const UserManagerPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle" className="d-inline">
        User Manager
      </h1>
      <UserSearch />
    </Layout>
  );
};
